import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import AuthService from '@/services/authService';

/**
 * Checks for `?force_init=true` query param.
 * If found, clears localStorage and redirects to OIDC login.
 */
export function useForceInitGuard() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('force_init') == 'true') {
      localStorage.clear();
      new AuthService().signInRedirect();
    }
  }, [searchParams]);
}
